export default __webpack_public_path__ + "static/media/pizza3.6b244773.jpg";